/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import type Router from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import { get } from 'embercom/lib/ajax';

export default class FinAiAgentSalesIndexRoute extends Route {
  @service declare router: Router;
  @service declare appService: AppService;

  async beforeModel() {
    try {
      let response = await get('/teammate_app/agent_deployment_statuses', {
        app_id: this.appService.app.id,
      });
      if (response?.sales) {
        this.router.replaceWith('apps.app.automation.fin-ai-agent.sales.performance');
        return;
      }
    } catch {
      // Fall through to get-started on API failure
    }
    this.router.replaceWith('apps.app.automation.fin-ai-agent.sales.get-started');
  }
}
